export default "__VITE_ASSET__BnOW8oku__"